import { Flex } from "../../../../styled";
import {
  ReviewText,
  StatusGoldCircle,
} from "../ReviewsTable/ReviewsTable.styled";
import { type IRevAud } from "./RevAud.types";

export const mapRevAud = (data: any) => {
  return data?.data?.review?.list
    ? data.data.review.list.map((item: any) => ({
        ...item,
        attachments: item.attachments ? JSON.parse(item.attachments) : [],
      }))
    : ([] as IRevAud[]);
};
export const getReviewType = (type: number) => {
  switch (type) {
    case 4:
      return "Audit";
    case 5:
      return "Further Info Required";
    case 50:
      return "Further Info Provided";
    case 200:
      return "Internal Audit";
    case 210:
      return "Superintendent Visit";
    case 220:
      return "Manager Visit";
    case 230:
      return "Periodic Inspection";
    case 240:
      return "Management Review";
    case 250:
      return "Yacht Review";
    case 1000:
      return "Audit";
  }
};

export const getStatusValue = (status: number) => {
  switch (status) {
    case 240:
      return "M";
    case 250:
      return "Y";
    case 4:
    case 1000:
      return "A";
  }
};

interface IRenderRevAudStatusProps {
  revoked: null | number;
  status: number;
  ended: null | number;
  type: number;
}

export const renderRevAudStatus = ({
  type,
  revoked,
  status,
  ended,
}: IRenderRevAudStatusProps) => {
  if (revoked) {
    return <ReviewText fw="bold">Revoked</ReviewText>;
  }
  if (status === 10) {
    return (
      <Flex direction="column" align="center" gap={2}>
        <ReviewText blue fw="bold">
          Complete
        </ReviewText>
        {[250, 240, 4, 1000].includes(type) && (
          <StatusGoldCircle>{getStatusValue(type)}</StatusGoldCircle>
        )}
      </Flex>
    );
  }

  if (ended) {
    return <ReviewText fw="bold">Expired</ReviewText>;
  }

  return (
    <ReviewText red fw="bold">
      Open
    </ReviewText>
  );
};
